import React, { useEffect, useState } from 'react'
import { trackPromise } from 'react-promise-tracker';
import {firestore} from '../firebase'
import 'firebase/firestore'
import InputForm from './InputForm';
import InputResults from './InputResults';
import LoadingAnimation from './LoadingAnimation';

const Tweets = ({userName, profilePic}) => {
  const [results, setResults] = useState([])

  useEffect(() => {
    let newArray = []
    const getTweets = async () => {
      const data = await firestore.collection('tweet').orderBy('date', 'desc').get();
      data.forEach(doc => {
      newArray.push(doc.data());
      })
      setResults(newArray)
    }
    trackPromise(
    getTweets());
  }, [])
  
  const addTweet = (text, date) => {
    const newTweets = {}
    newTweets.content = text
    newTweets.date = date
    newTweets.userName = userName || 'Ryan Roberts'
    newTweets.photo = profilePic || 'https://i.stack.imgur.com/34AD2.jpg'
    firestore.collection("tweet").add(newTweets).then((docRef) => {
      console.log("Document written with ID: ", docRef.id);
  })
    setResults([newTweets, ...results])
  }

  return (
    <>
      <InputForm addTweet={addTweet} />
      <main className="tweet-container">
        <div className="tweet-container--content">
          {results.map((tweet, index) => (
            <InputResults
            key={index}
            tweet={tweet}
            />
            ))}
          <LoadingAnimation />
        </div>
      </main>
    </>
  )
}

export default Tweets
